import { axiosClientNotCached } from "../../network/index";

export default class supportService {
  static createSubjectStartDetails(payload) {
    return axiosClientNotCached
      .post("user/createMessage", payload, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return {
          error
        };
      });
  }

  static getSupportSubjectsDetails(payload) {
    return axiosClientNotCached
      .get(
        `user/getSupportTickets?page=${payload.currentPage}&limit=${payload.limit}`
      )
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return {
          error
        };
      });
  }

  static getSupportMessagesDetails(payload) {
    return axiosClientNotCached
      .get(`user/getSupportTicketMessages?page=1&limit=100&ticketId=${payload}`)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return {
          error
        };
      });
  }

  static createMessageDetails(payload) {
    return axiosClientNotCached
      .post("user/createMessage", payload)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return {
          error
        };
      });
  }
}
